import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const SHIPMENTS_SHIPMENT_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/shipments',
        name: '::Menu:Shipments',
        iconClass: 'fas fa-shipping-fast',
        layout: eLayoutType.application,
        requiredPolicy: 'ReturnLy.Shipments.Create && ReturnLy.Shipments.Edit && ReturnLy.Shipments.Delete',
        parentName: '::Menu:Configurations',
      },
    ]);
  };
}
